<template>
  <div class="popup-price" :class="{ 'active': popup }">
    <div class="popup__backdrop" @click="closePopup"></div>
    <div class="popup__box">
      <div class="close" @click="closePopup"><span class="fi-rr-cross"></span></div>
      <div class="title"><h1>{{ phone.seo_title }}</h1></div>
      <div class="data">
        <p>Prix à payer en magasin: <span>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.prices_floats.store) }}</span></p>
        <p v-if="phone.defaults.subscription && phone.fraxio.price">+ Facilité de paiement {{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.fraxio.price) }} x {{ phone.fraxio.formated_duration }}</p>
        <p v-if="phone.defaults.subscription && phone.fraxio.price">Frais de dossier paiement plusieurs fois : 20€</p>
      </div>
      <div class="title" v-if="flashOffers.length && phoneHasOffers"><h2>Remboursement(s) immédiat</h2></div>
      <div class="data" v-if="flashOffers.length && phoneHasOffers">
        <p v-for="(offer, index) in flashOffers" :key="index">{{ offer.nomPublic }}</p>
        <p class="small">Total remboursement immédiat: <span>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(flashAmount) }}</span></p>
      </div>
      <div class="title" v-if="moneyBackOffers.length && phoneHasOffers"><h2>Remboursement(s) après achat</h2></div>
      <div class="data" v-if="moneyBackOffers.length && phoneHasOffers">
        <p v-for="(offer, index) in moneyBackOffers" :key="index">{{ offer.nomPublic }}</p>
        <p class="small">Total remboursement après achat: <span>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(moneyBackAmount) }}</span></p>
      </div>
      <div class="title" v-if="bonusOffers.length && phoneHasOffers"><h2>Bonus reprise</h2></div>
      <div class="data" v-if="bonusOffers.length && phoneHasOffers">
        <p v-for="(offer, index) in bonusOffers" :key="index">{{ offer.nomPublic }}</p>
        <p class="small">Total remboursement après achat: <span>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(bonusAmount) }}</span></p>
      </div>
      <div class="data">
        <p>Coût final : <span>{{ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(phone.prices_floats.display) }}</span></p>
      </div>
    </div>
  </div>
</template>

<script>
import CheckBox from './CheckBox'
import SmallLoader from './SmallLoader'
import SearchPlace from './SearchPlace'

import { PerfectScrollbar } from 'vue3-perfect-scrollbar'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PricePopup',
  computed: {
    ...mapState({
      phone: state => state.phone.item,
      popup: state => state.prices.popup
    }),
    moneyBackOffers () {
      const offers = []
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'ODR' || offer.typePromotion.nom === 'ODR Assu' || offer.typePromotion.nom === 'Flash Assu') {
            offers.push(offer)
          }
        })
      }
      return offers
    },
    moneyBackAmount () {
      let amount = 0
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'ODR' || offer.typePromotion.nom === 'ODR Assu' || offer.typePromotion.nom === 'Flash Assu') {
            amount = amount + offer.montant
          }
        })
      }
      return amount
    },
    flashOffers () {
      const offers = []
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'FLASH') {
            offers.push(offer)
          }
        })
      }
      return offers
    },
    flashAmount () {
      let amount = 0
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'FLASH') {
            amount = amount + offer.montant
          }
        })
      }
      return amount
    },
    bonusOffers () {
      const offers = []
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'BONUS REPRISE') {
            offers.push(offer)
          }
        })
      }
      return offers
    },
    bonusAmount () {
      let amount = 0
      if(this.phone.offers && this.phone.offers.length) {
        this.phone.offers.forEach((offer) => {
          if (offer.typePromotion.nom === 'BONUS REPRISE') {
            amount = amount + offer.montant
          }
        })
      }
      return amount
    },
    phoneHasOffers () {
      let offers = []
      if(this.phone) offers = this.phone.offers
      return !!(offers.length)
    },
    phoneNotAlone () {
      return (this.phone.defaults.subscription)
    }
  },
  methods: {
    ...mapActions('prices', ['closePopup']),
  }
}
</script>

<style src="vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css"/>
<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.popup-price{
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  height: 100vh;
  width: 100vw;
  overflow: scroll;

  @include responsive(mobile) {
    padding: 20px;
    background-color: rgba($black, 0.9);
  }

  &.active{
    display: block;

    @include responsive(mobile) {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .popup__backdrop{
    background-color: rgba($black, 0.9);
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;

    @include responsive(mobile) {
      display: none;
    }
  }

  .popup__box{
    max-width: 500px;
    background-color: $white;
    padding: 30px;
    padding-right: 60px;
    position: absolute;
    top: 50%;
    left: 50%;
    @include transform(translateX(-50%) translateY(-50%) translateZ(0));
    @include radius(10px);

    @include responsive(mobile) {
      top: initial;
      left: initial;
      padding: 20px;
      position: relative;
      @include transform(translateX(0) translateY(0) translateZ(0));
    }

    .close {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 10px;
      right: 10px;
      text-align: center;
      line-height: 42px;
      color: $white;
      cursor: pointer;
      padding-left: 1px;
      background-color: rgba($black, 0.2);
      @include radius(100%);
      @include transition();

      &:hover {
        background-color: $primary;
      }
    }

    .title{
      h1{
        font-size: px2rem(22px);
        line-height: px2rem(30px);
      }

      h2{
        font-size: px2rem(18px);
        line-height: px2rem(26px);
        font-weight: $fontSemiBold;
      }
    }

    .data{
      padding: 10px 0 20px 0;
      border-bottom: 1px solid rgba($black, 0.2);
      margin-bottom: 20px;

      &:last-child{
        border-bottom: none;
        margin-bottom: 0;
        padding: 10px 0 0 0;
      }

      p{
        font-size: px2rem(15px);
        line-height: px2rem(22px);
        font-weight: $fontMedium;

        span{
          color: $primary;
        }

        &.small{
          font-size: px2rem(12px);
          line-height: px2rem(18px);
          font-weight: $fontRegular;
          padding-top: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.popup-store{
  .popup__box{
    .stores{
      .ps{
        height: 355px;
        padding-right: 20px;

        @include responsive(mobile) {
          padding-right: 0;
        }

        .ps__rail-y{
          width: 6px;
          opacity: 0.7;
          margin: 0;

          &:hover, &.ps--clicking{
            background: none;
            opacity: 1;

            .ps__thumb-y{
              width: 6px;
            }
          }

          .ps__thumb-y{
            background-color: rgba(black, 0.5);
            right: 0;
          }
        }
      }
    }
  }
}
</style>
